var _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApartment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Add_Apartment",
    "data-name": "Add Apartment",
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_62739",
    "data-name": "Group 62739",
    transform: "translate(31.017 16.28)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_479",
    "data-name": "Path 479",
    d: "M200,104v56.492h17.193v-51.58Z",
    transform: "translate(-200 -104)",
    fill: "rgba(21,172,142,0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_480",
    "data-name": "Path 480",
    d: "M312,184v44.211h9.825v-39.3Z",
    transform: "translate(-294.807 -171.719)",
    fill: "rgba(21,172,142,0.47)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 3.5,
    cy: 5,
    rx: 3.5,
    ry: 5,
    transform: "translate(32.298 38.035)",
    fill: "rgba(21,172,142,0.47)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_481",
    "data-name": "Path 481",
    d: "M67.833,71.533V65.147a6.068,6.068,0,0,0,3.7-5.947c0-3.4-2.213-6.167-4.933-6.167S61.667,55.8,61.667,59.2a6.068,6.068,0,0,0,3.7,5.947v6.386H59.2V33.3a1.234,1.234,0,0,0-.682-1.1L49.333,27.6V20.967a1.233,1.233,0,0,0-.894-1.186L32.067,15.1V1.233A1.233,1.233,0,0,0,30.833,0H6.167A1.233,1.233,0,0,0,4.933,1.233v70.3H0V74H74V71.533ZM64.133,59.2c0-2.005,1.13-3.7,2.467-3.7s2.467,1.695,2.467,3.7a4.317,4.317,0,0,1-1.233,3.17V60.433H65.367V62.37A4.309,4.309,0,0,1,64.133,59.2ZM7.4,69.067H18.5V66.6H7.4V61.667H18.5V59.2H7.4V54.267H18.5V51.8H7.4V46.867H18.5V44.4H7.4V39.467H18.5V37H7.4V32.067H18.5V29.6H7.4V24.667H18.5V22.2H7.4V17.267H18.5V14.8H7.4V9.867H18.5V7.4H7.4V2.467H29.6V71.533H7.4Zm24.667,0H40.7V66.6H32.067V61.667H40.7V59.2H32.067V54.267H40.7V51.8H32.067V46.867H40.7V44.4H32.067V39.467H40.7V37H32.067V32.067H40.7V29.6H32.067V24.667H40.7V22.2H32.067V17.669l14.8,4.228V71.533h-14.8Zm17.267,2.467V69.067h3.7V66.6h-3.7V61.667h3.7V59.2h-3.7V54.267h3.7V51.8h-3.7V46.867h3.7V44.4h-3.7V39.467h3.7V37h-3.7V30.362l7.4,3.7V71.533Z",
    fill: "#0b5647"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApartment);
export default __webpack_public_path__ + "static/media/Apartment.e28607bf4b87cb05e287076bf67413d0.svg";
export { ForwardRef as ReactComponent };